import { useEffect, useState } from "react";
import { Building2, LoaderCircle } from "lucide-react";
import { api } from "./api";
import { ChunkzLogin, ChunkzShell } from "./Chunkz";
import type { User } from "../shared/types";

export default function App() {
  const [user, setUser] = useState<User | null | undefined>();
  useEffect(() => {
    api<{ user: User | null }>("/api/auth/me").then((result) => setUser(result.user)).catch(() => setUser(null));
    const signedOut = () => setUser(null);
    window.addEventListener("vps360:unauthorised", signedOut);
    return () => window.removeEventListener("vps360:unauthorised", signedOut);
  }, []);
  if (user === undefined) return <div className="boot"><Building2 /><LoaderCircle className="spin" /></div>;
  if (!user) return <ChunkzLogin />;
  return <ChunkzShell user={user} signOut={async () => { await api("/api/auth/logout", { method: "POST" }); window.location.replace("/"); }} />;
}
